// hotjar.js
'use strict';
import loadScriptTag from '../resource/loadScriptTag.js';

const HOTJAR_SCRIPT_ID = 'hotjar-script';

const isServer = typeof window === 'undefined';
const search = new URLSearchParams(isServer ? '' : window.location.search);
const searchIsDebug = !!search.get('debug-hotjar');

const initHotjar = async ({ siteId, version, options } = {}) => {
  if (!siteId || !version || window.hj) return;

  const isDebug = options?.debug ?? searchIsDebug ?? false;

  const hotjarScriptCode = `(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${siteId},hjsv:${version},hjdebug:${isDebug}};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;

  await loadScriptTag({
    id: HOTJAR_SCRIPT_ID,
    async: false,
    textContent: hotjarScriptCode,
  });

  if (window.hj) return true;
  return false;
};

const executeHotjarCommand = (command, ...args) => {
  return window.hj?.(command, ...args);
};

const hotjarEvent = ({ actionName }) => {
  return executeHotjarCommand('event', actionName);
};

const hotjarIdentify = ({ clientId, userInfo }) => {
  return executeHotjarCommand('identify', clientId, userInfo);
};

const stateChange = ({ relativePath }) => {
  return executeHotjarCommand('stateChange', relativePath);
};

// From the hotjar.js console log
const HOTJAR_EVENT_NAME_MAX_LENGTH = 250;
const REQUIRE_PROPERTY_KEYS = ['button.id', 'modal.id', 'view.id'];

const pipeMixpanelEventToHotjar = ({ event, properties }) => {
  if (window.hj) {
    try {
      let propertiesString = '';

      // Follow the order to create the string
      REQUIRE_PROPERTY_KEYS.forEach(key => {
        if (properties[key]) {
          propertiesString = `${propertiesString}_${key}-${properties[key]}`;
        }
      });

      const actionName = `${event}${propertiesString}`.slice(
        0,
        HOTJAR_EVENT_NAME_MAX_LENGTH
      );

      return hotjarEvent({ actionName });
    } catch (_) {
      //
    }
  }
};

export {
  initHotjar,
  hotjarEvent,
  hotjarIdentify,
  stateChange,
  pipeMixpanelEventToHotjar,
};
